import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ArticleCard from "@/components/public/ArticleCard";
import { useSite } from "@/context/SiteContext";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function ArticleList() {
  const [articles, setArticles] = useState([]);
  const [params] = useSearchParams();
  const search = params.get("q") || "";
  const { categories } = useSite();
  const [activeCat, setActiveCat] = useState("");

  useEffect(() => {
    let url = "/articles?limit=60";
    if (activeCat) url += `&category=${activeCat}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    api.get(url).then((r) => setArticles(r.data || [])).catch(() => {});
  }, [activeCat, search]);

  return (
    <div className="pt-32 md:pt-40 max-w-[1400px] mx-auto px-5 md:px-10 min-h-screen">
      <SEO title="Artículos" description="Archivo editorial: todas nuestras historias de cultura, viajes, gastronomía y estilo de vida." />
      <header className="mb-12">
        <p className="kicker text-sunset-accent mb-4">Archivo Editorial</p>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight">Artículos</h1>
      </header>

      <div className="flex flex-wrap gap-2 mb-14 pb-8 border-b border-sunset-border">
        <button onClick={() => setActiveCat("")} data-testid="filter-all"
          className={`kicker text-[10px] px-4 py-2 border transition-colors ${activeCat === "" ? "bg-sunset-ink text-white border-sunset-ink" : "border-sunset-border hover:border-sunset-ink"}`}>Todos</button>
        {categories.map((c) => (
          <button key={c.id} onClick={() => setActiveCat(c.slug)}
            className={`kicker text-[10px] px-4 py-2 border transition-colors ${activeCat === c.slug ? "bg-sunset-ink text-white border-sunset-ink" : "border-sunset-border hover:border-sunset-ink"}`}>{c.name}</button>
        ))}
      </div>

      {articles.length === 0 ? (
        <p className="text-sunset-muted py-20 text-center">No hay artículos disponibles.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
          {articles.map((a, i) => <ArticleCard key={a.id} article={a} size="md" index={i} />)}
        </div>
      )}
    </div>
  );
}
